import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/google-session", { session_id: sid, role: "agent" });
        if (r.data?.token) localStorage.setItem("trawell_token", r.data.token);
        setUser(r.data.user);
        // strip hash
        window.history.replaceState({}, "", window.location.pathname);
        nav("/dashboard", { replace: true, state: { user: r.data.user } });
      } catch {
        nav("/login?error=oauth", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-brand border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="overline mt-6">Establishing secure session</p>
      </div>
    </div>
  );
}
